import router from "next/router";
import React from "react";
import { useValidSubscription } from "../../../hooks/useValidSubscription";

const LockedContentWrapper = (props: {
  placeholderContent: any;
  children: any;
  message?: any;
  alignment?: string;
}) => {
  const hasValidSubscription = useValidSubscription();

  const redirectToSignIn = () => {
    router.push({ pathname: "/users/sign_in", query: { from: router.asPath } });
  };

  return (
    <div>
      {hasValidSubscription ? (
        props.children
      ) : (
        <div className="relative">
          <div
            className={`absolute inset-0 flex items-${
              props.alignment || "center"
            } justify-${
              props.alignment || "center"
            } font-bold text-xl z-10`}
          >
            {props.message ? (
              props.message
            ) : (
              <p>
                <button onClick={() => redirectToSignIn()} className="text-red">
                  Log In
                </button>{" "}
                or{" "}
                <a
                  href="users/plan"
                  className="text-red"
                >
                  Sign Up
                </a>{" "}
                to View This Content
              </p>
            )}
          </div>
          <div className="blur relative opacity-50 select-none">
            {props.placeholderContent}
          </div>
        </div>
      )}
    </div>
  );
};

export default LockedContentWrapper;
